"use client"
import styled from "@emotion/styled"

const StyledError = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
`

type GeneralErrorMsgProps = {
  error: string
}

const GeneralErrorMsg = ({ error }: GeneralErrorMsgProps) => {
  return <StyledError>{error}</StyledError>
}
export default GeneralErrorMsg
